import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import { getTokenSilent, refreshToken } from '../auth/authMsal';
import { AGENTIC_MS_USER_INFO, AUTHORIZATION_TOKEN } from '../constants/appConstants';
import { getEnv } from '../utils/envConfig';

// Create an Axios instance with a base URL
const axiosInstance = axios.create({
  baseURL: getEnv('VITE_API_BASE_URL'),
  //5 minutes timeout
  timeout: 300000,
  headers: {
    'Content-Type': 'application/json',
  },
});
let refreshPromise: Promise<any> | null = null;
axiosInstance.interceptors.request.use(async (config) => {

  
  let token = sessionStorage.getItem(AUTHORIZATION_TOKEN);
  const userInfoStr = sessionStorage.getItem(AGENTIC_MS_USER_INFO);

  let expiresAt = 0;
  if (userInfoStr) {
    try {
      const userInfo = JSON.parse(userInfoStr);
      // For testing, override expiry to 12:22 IST
      // const testExpiryIST = "2025-08-26T12:22:00+05:30";
      const testExpiryIST = userInfo.expires_in;
      expiresAt = new Date(testExpiryIST).getTime();
    } catch {
      expiresAt = 0;
    }
  }
  const refreshBuffer = 2 * 60 * 1000;
  // If token missing or expired → fetch new one
  if (!token || Date.now() >= expiresAt - refreshBuffer) {
    if (!refreshPromise) {
      console.log("Token expired! Fetching new one...");
      refreshPromise = refreshToken().then((response: any) => {
        token = response.accessToken ?? "";
        refreshPromise = null; // reset
        return token;
      }).catch((error: any) => {
        refreshPromise = null;
        throw error;
      });
    }
    token = await refreshPromise;
  }

  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

// Add an interceptor to the Axios instance to modify the request before it is sent
// axiosInstance.defaults.headers.common.Authorization = `Bearer ${sessionStorage.getItem('AUTHORIZATION_TOKEN') || ''}`;

const reqInterceptor = (config: AxiosRequestConfig): any => {
  return config;
};

axiosInstance.interceptors.request.use(reqInterceptor, (err) =>
  Promise.reject(err),
);

axiosInstance.interceptors.response.use(
  (response: any) => {
    return response;
  },
  (error: AxiosError<any>) => {
    const requestUrl = error.response?.config.url;
    if (error.response?.status === 403) {
      //Dispatch logout action here....
    }
    return Promise.reject({
      status: error.response?.status,
      error: error.response?.data,
    });
  },
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    let actionError = null;

    if (error.response) {
      if (error.response.code === 900901 && error.response.status === 401) {
        getTokenSilent();
        window.location.reload();
      } else {
        //  store.dispatch(logout());
        console.log('Refresh token expired.');
      }
      throw error;
    }
    throw error;
  }
);


export default axiosInstance;